export default __webpack_public_path__ + "static/media/chicken_grayscale.4f7e7f1d.svg";